import React, { useState } from "react";
import { Tag, X } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useCart } from "@/context/CartContext";

// Enter / remove a discount code. The saving itself comes back on the checkout quote.
export const DiscountCodeBox = ({ quote, testPrefix = "cart" }) => {
  const { discountCode, setDiscountCode } = useCart();
  const [draft, setDraft] = useState("");
  const [busy, setBusy] = useState(false);
  const applied = quote?.discount?.code;
  const error = quote?.discount?.code_error;

  const apply = async () => {
    const code = draft.trim().toUpperCase();
    if (!code) return;
    setBusy(true);
    try {
      const { data } = await api.post("/discount-codes/check", { code });
      setDiscountCode(data.code);
      setDraft("");
      toast.success(`${data.code} applied — ${data.label}`);
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };

  if (discountCode) {
    return (
      <div className={`mt-3 flex items-center justify-between gap-2 border px-3 py-2 text-sm ${error ? "border-destructive/60" : "border-primary/50 bg-primary/5"}`} data-testid={`${testPrefix}-discount-applied`}>
        <div className="flex min-w-0 items-center gap-2">
          <Tag className="h-3.5 w-3.5 shrink-0 text-primary" />
          <div className="min-w-0">
            <div className="mono text-xs font-bold uppercase tracking-[0.12em]">{discountCode}</div>
            <div className={`truncate text-[11px] ${error ? "text-destructive" : "text-muted-foreground"}`} data-testid={`${testPrefix}-discount-status`}>{error || applied?.label || "Checking…"}</div>
          </div>
        </div>
        <button type="button" data-testid={`${testPrefix}-discount-remove`} onClick={() => setDiscountCode("")} className="rounded-full p-1 hover:bg-muted" aria-label="Remove discount code"><X className="h-3.5 w-3.5" /></button>
      </div>
    );
  }
  return (
    <div className="mt-3 flex gap-1.5" data-testid={`${testPrefix}-discount-form`}>
      <input data-testid={`${testPrefix}-discount-input`} value={draft} onChange={(e) => setDraft(e.target.value.toUpperCase())} onKeyDown={(e) => e.key === "Enter" && apply()}
        placeholder="Discount code" className="mono flex-1 rounded-none border border-border bg-background px-3 py-2 text-sm uppercase tracking-[0.1em] placeholder:normal-case placeholder:tracking-normal" />
      <button type="button" data-testid={`${testPrefix}-discount-apply`} onClick={apply} disabled={busy || !draft.trim()}
        className="mono border border-border px-3 py-2 text-[10px] font-bold uppercase tracking-[0.15em] transition-colors hover:border-primary hover:text-primary disabled:opacity-40">Apply</button>
    </div>
  );
};
